import config from './config.json';

const Config = {
  API_BASE_URL: config.API_BASE_URL,
  API_HEADDERS: config.API_HEADDERS
};

// Helper function to get headers with token
const getHeadersWithToken = () => {
  const user = localStorage.getItem('user');
  let headers = { ...Config.API_HEADDERS };
  if (user) {
    const userData = JSON.parse(user);
    headers['Authorization'] = `Basic ${userData.Token}`;
  }

  return headers;
};

const CategoriesInDropdown = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "CategoriesInDropdown", {
      method: "GET",
      headers: getHeadersWithToken(),
      // body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const LatestProductsInHome = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "LatestProductsInHome", {
      method: "GET",
      headers: getHeadersWithToken(),
      // body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const OffersInHome = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "OffersInHome", {
      method: "GET",
      headers: getHeadersWithToken(),
      // body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const TopSellingProductsInHome = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "TopSellingProductsInHome", {
      method: "GET",
      headers: getHeadersWithToken(),
      // body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const ProductsByFilter = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "ProductsByFilter", {
      method: "POST",
      headers: getHeadersWithToken(),
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const GetProductById = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "GetProductById/" + data, {
      method: "GET",
      headers: getHeadersWithToken(),
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const GetSimilarProductsById = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "GetSimilarProductsById/" + data, {
      method: "GET",
      headers: getHeadersWithToken(),
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const registerCustomer = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "registerCustomer", {
      method: "POST",
      headers: Config.API_HEADDERS,
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const Login = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "Login", {
      method: "POST",
      headers: Config.API_HEADDERS,
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};
 
const AddCusAddress = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "AddCusAddress", {
      method: "POST",
      headers: getHeadersWithToken(),
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};


const getCustomerAddresses = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "getCustomerAddresses/" + data, {
      method: "GET",
      headers: getHeadersWithToken(),
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};


const SaveBooking = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "SaveBooking", {
      method: "POST",
      headers: getHeadersWithToken(),
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};


const myBookings = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "myBookings/" + data, {
      method: "GET",
      headers: getHeadersWithToken(),
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const getCustomerById = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "getCustomerById/" + data, {
      method: "GET",
      headers: getHeadersWithToken(),
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const updateCustomerData = data => {
  return new Promise((resolve, reject) => {
    fetch(Config.API_BASE_URL + "updateCustomerData", {
      method: "POST",
      headers: getHeadersWithToken(),
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(responseJson => {
        resolve(responseJson);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const MainService = {
  CategoriesInDropdown,
  LatestProductsInHome,
  OffersInHome,
  TopSellingProductsInHome,
  ProductsByFilter,
  GetProductById,
  GetSimilarProductsById,
  registerCustomer,
  Login,
  AddCusAddress,
  getCustomerAddresses,
  SaveBooking,
  myBookings,
  getCustomerById,
  updateCustomerData
};

export default MainService; 